module.exports = __webpack_public_path__ + "img/ok.57b7f225.png";